<template>
  <div class="planner-page">
    <h2 class="planner-header">Planner</h2>
    <div class="planner-video">
      <div>
        <!-- <a target="_blank" rel="noopener noreferrer" class="btn" href="https://youtu.be/1MWwjAutl7o?t=29">HELP: how to use the planner...</a> -->
        <b-card>
          <div class="long-videos">
            <div class="">
              <div class="long-video-container">
                <div class="long-thumbnail">
                  <img :src="video.data.thumbnail" class="long-thumbnail-image" v-b-modal.thumbnailUpload />
                  <b-modal
                    id="thumbnailUpload"
                    centered
                    title="Upload Thumbnail"
                    @ok="updateVideo"
                    ok-title="Save"
                    size="xl"
                  >
                    <div >
                      <input class="btn" type="file" ref="input1"
                        @change="previewImage" accept="image/*" >
                    </div>
                    File size must be 2MB or less.
                    <div v-if="video.data.thumbnail">
                        <img class="preview" height="268" :src="video.data.thumbnail">
                    <br>
                    </div>
                    {{uploadValue}}
                    <div class="mt-3">Selected file: {{ video.data.thumbnail ? video.data.thumbnail.name : '' }}</div>
                  </b-modal>
                </div>
                <div class="long-video-right-section">
                  <div v-if="!isVisibleEditTitle" @click="editTitle" class="long-video-title">{{ video.data.title ? video.data.title : 'Title goes here...' }}</div>
                  <!-- <div v-if="!isVisibleEditTitle" @click="editTitle" class="long-video-title">{{ title ? title : 'Title goes here...' }}</div> -->
                  <div v-else :class="$style.editSection">
                    <b-input-group @submit.prevent="updateVideo" size="sm" class="mb-4">
                      <b-form-input v-model="cloneVideo.data.title" type="text" autocomplete="off" placeholder="Title goes here..." size="lg" required></b-form-input>
                      <b-input-group-append>
                        <b-button @click="updateVideo" variant="outline-danger">OK</b-button>
                        <b-button @click="hideEdit" variant="outline-primary">CANCEL</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div class="long-video-metadata">
                    <span v-if="!video.data.titleComplete">Create title</span>
                    <span v-else-if="!video.data.thumbnailComplete">Create thumbnail</span>
                    <span v-else-if="!video.data.scriptComplete">Write script</span>
                    <span v-else-if="!video.data.filmComplete">Ready to film</span>
                    <span v-else-if="!video.data.editComplete">Ready to edit</span>
                    <span v-else-if="!video.data.tagsComplete">Choose tags</span>
                    <span v-else-if="!video.data.descriptionComplete">Write description</span>
                    <span v-else-if="!video.data.uploadComplete">Upload to YouTube</span>
                    <span v-else-if="!video.data.promoteComplete">Ready to promote</span>
                    <span v-else-if="!video.data.publishComplete">Ready to publish</span>
                    <span v-else-if="!video.data.engageComplete">Engage comments</span>
                    •
                    <span>In {{ -publishCounter }} days</span>
                  </div>
                  <div class="long-video-metadata">
                    <!-- <img class="channel-icon" :src="youtube.channelSnippet[0].snippet.thumbnails.medium.url" /> -->
                    <!-- <span class="long-video-channel-name">{{
                      youtube.channelSnippet[0].snippet.title
                    }}</span> -->
                  </div>
                  <div class="long-video-metadata" v-if="!isVisibleEditDescription && video.data.description" @click="editDescription">
                    {{ video.data.description }}
                  </div>
                  <div class="long-video-metadata" v-if="!isVisibleEditDescription && !video.data.description">
                    The description will go here...
                  </div>
                  <div v-if="isVisibleEditDescription" :class="$style.editSection">
                    <b-form-textarea
                      id="textarea"
                      v-model="cloneVideo.data.description"
                      placeholder="Enter description here..."
                      rows="3"
                      max-rows="6"
                      @keyup="characterCounter"
                    ></b-form-textarea>
                    <span>{{ characterCount ? characterCount : 0 }} / 4000 total char.</span>
                    <b-input-group-append>
                      <b-button @click="updateVideo" variant="outline-danger">OK</b-button>
                      <b-button @click="hideEdit" variant="outline-primary">Back</b-button>
                    </b-input-group-append>
                  </div>
                  <div>
                    <button type="button" class="btn" v-b-modal.videoTags>Video Tags</button>
                    <b-modal
                    id="videoTags"
                    centered
                    title="Choose Video Tags"
                    @ok="updateVideo"
                    ok-title="Save"
                    size="xl"
                    v-if="cloneVideo"
                    >
                      <p>Press Enter/Return or comma to separate tags.</p>
                      <button class="video-tag" v-for="tag in cloneVideo.data.tags" :key="tag">
                        {{tag}} <i @click="removeTag(tag)" class="remove fa fa-trash"></i></button>
                      <b-form-input @keydown.enter.188.tab.prevent.stop="addTag" type="text" v-model="newTag"></b-form-input>
                    </b-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <b-modal id="removeVideo" title="Are you sure you want to delete this video?" centered @ok="removeVideo"></b-modal>
    </div>
    <div class="planner-todos">
      <div class="card" v-if="cloneVideo">
        <h4 class="card-header cui__utils__heading mb-0">Production Tasks</h4>
        <div class="card-body mb-5">
          <p>Click <i class="fe fe-calendar"></i> to change due dates.</p>
          <div class="text-gray-6">
            <ul class="list-unstyled">
              <li class="mb-3" :key="video.data.titleComplete + 'title'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.titleDueModal></i>
                  <strong class="text-white">Create title</strong>
                  <div v-if="!video.data.titleComplete && titleCounter >= -7" :class="$style.badge">
                    <b-badge v-if="titleChecker === 'past'" class="mr-2" variant="danger">{{titleCounter}} days ago</b-badge>
                    <b-badge v-else-if="titleChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-titleCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.titleComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="titleDueModal" title="Change Title Due Date" @ok="updateVideo" ref="titleDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your title completed.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.titleDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.thumbnailComplete + 'thumbnail'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.thumbnailDueModal></i>
                  <strong class="text-white">Create Thumbnail</strong>
                  <div v-if="!video.data.thumbnailComplete && thumbnailCounter >= -7" :class="$style.badge">
                    <b-badge v-if="thumbnailChecker === 'past'" class="mr-2" variant="danger">{{thumbnailCounter}} days ago</b-badge>
                    <b-badge v-else-if="thumbnailChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-thumbnailCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.thumbnailComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="thumbnailDueModal" title="Change Thumbnail Due Date" @ok="updateVideo" ref="thumbnailDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your thumbnail completed.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.thumbnailDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.scriptComplete + 'script'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.scriptDueModal></i>
                  <strong class="text-white">Write script</strong>
                  <div v-if="!video.data.scriptComplete && scriptCounter >= -7" :class="$style.badge">
                    <b-badge v-if="scriptChecker === 'past'" class="mr-2" variant="danger">{{scriptCounter}} days ago</b-badge>
                    <b-badge v-else-if="scriptChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-scriptCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.scriptComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="scriptDueModal" title="Change Script Due Date" @ok="updateVideo" ref="scriptDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your script completed.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.scriptDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.filmComplete + 'film'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.filmDueModal></i>
                  <strong class="text-white">Film</strong>
                  <div v-if="!video.data.filmComplete && filmCounter >= -7" :class="$style.badge">
                    <b-badge v-if="filmChecker === 'past'" class="mr-2" variant="danger">{{filmCounter}} days ago</b-badge>
                    <b-badge v-else-if="filmChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-filmCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.filmComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="filmDueModal" title="Change Film Due Date" @ok="updateVideo" ref="filmDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your filming completed.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.filmDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.editComplete + 'edit'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.editDueModal></i>
                  <strong class="text-white">Edit</strong>
                  <div v-if="!video.data.editComplete && editCounter >= -7" :class="$style.badge">
                    <b-badge v-if="editChecker === 'past'" class="mr-2" variant="danger">{{editCounter}} days ago</b-badge>
                    <b-badge v-else-if="editChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-editCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.editComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="editDueModal" title="Change Edit Due Date" @ok="updateVideo" ref="editDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your editing completed.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.editDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.tagsComplete + 'tags'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.tagsDueModal></i>
                  <strong class="text-white">Choose tags</strong>
                  <div v-if="!video.data.tagsComplete && tagsCounter >= -7" :class="$style.badge">
                    <b-badge v-if="tagsChecker === 'past'" class="mr-2" variant="danger">{{tagsCounter}} days ago</b-badge>
                    <b-badge v-else-if="tagsChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-tagsCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.tagsComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="tagsDueModal" title="Change Tags Due Date" @ok="updateVideo" ref="tagsDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your tags completed.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.tagsDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.descriptionComplete + 'description'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.descriptionDueModal></i>
                  <strong class="text-white">Write description</strong>
                  <div v-if="!video.data.descriptionComplete && descriptionCounter >= -7" :class="$style.badge">
                    <b-badge v-if="descriptionChecker === 'past'" class="mr-2" variant="danger">{{descriptionCounter}} days ago</b-badge>
                    <b-badge v-else-if="descriptionChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-descriptionCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.descriptionComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="descriptionDueModal" title="Change Description Due Date" @ok="updateVideo" ref="descriptionDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your description completed.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.descriptionDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.uploadComplete + 'upload'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.uploadDueModal></i>
                  <strong class="text-white">Upload to YouTube</strong>
                  <div v-if="!video.data.uploadComplete && uploadCounter >= -7" :class="$style.badge">
                    <b-badge v-if="uploadChecker === 'past'" class="mr-2" variant="danger">{{uploadCounter}} days ago</b-badge>
                    <b-badge v-else-if="uploadChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-uploadCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.uploadComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="uploadDueModal" title="Change Upload Due Date" @ok="updateVideo" ref="uploadDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll have your video uploaded.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.uploadDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.promoteComplete + 'promote'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.promoteDueModal></i>
                  <strong class="text-white">Promote</strong>
                  <div v-if="!video.data.promoteComplete && promoteCounter >= -7" :class="$style.badge">
                    <b-badge v-if="promoteChecker === 'past'" class="mr-2" variant="danger">{{promoteCounter}} days ago</b-badge>
                    <b-badge v-else-if="promoteChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-promoteCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.promoteComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="promoteDueModal" title="Change Promote Due Date" @ok="updateVideo" ref="promoteDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll promote your video before it goes live.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.promoteDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.publishComplete + 'publish'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.publishDueModal></i>
                  <strong class="text-white">Publish!</strong>
                  <div v-if="!video.data.publishComplete && publishCounter >= -7" :class="$style.badge">
                    <b-badge v-if="publishChecker === 'past'" class="mr-2" variant="danger">{{publishCounter}} days ago</b-badge>
                    <b-badge v-else-if="publishChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-publishCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.publishComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="publishDueModal" title="Change Publish Date" @ok="updateVideo" ref="publishDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll publish your video.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.publishDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
              <li class="mb-3" :key="video.data.engageComplete + 'engage'">
                <div :class="$style.head" @change="setHasChanges">
                  <i class="fe fe-calendar icon" v-b-modal.engageDueModal></i>
                  <strong class="text-white">Engage community</strong>
                  <div v-if="!video.data.engageComplete && engageCounter >= -7" :class="$style.badge">
                    <b-badge v-if="engageChecker === 'past'" class="mr-2" variant="danger">{{engageCounter}} days ago</b-badge>
                    <b-badge v-else-if="engageChecker === 'today'" class="mr-2" variant="warning">Due today</b-badge>
                    <b-badge v-else class="mr-2" variant="info">In {{-engageCounter}} days</b-badge>
                  </div>
                  <b-form-checkbox v-model="video.data.engageComplete" switch @formchange="setHasChanges" :class="$style.time" />
                </div>
                <b-modal id="engageDueModal" title="Change Engage Due Date" @ok="updateVideo" ref="engageDueModal"  @hide="hideEdit">
                  <b-form @submit.prevent="updateVideo">
                    <b-form-group label="New Due Date" label-for="input-1" description="This is the date you'll engage your viewers and commenters.">
                      <b-form-datepicker
                        id="input-1"
                        v-model="cloneVideo.data.engageDue"
                        required>
                      </b-form-datepicker>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </li>
            </ul>
          </div>
        </div>
        <b-button v-show="hasChanges" @click="updateVideo" variant="primary">Save and Update</b-button>
      </div>
      <b-button variant="outline-danger" v-b-modal.removeVideo>Delete Video</b-button>
    </div>
  </div>
</template>

<script>
import { firebaseStorage } from '@/services/firebase'
import moment from 'moment'
import { mapState } from 'vuex'
// import getVideoId from 'get-video-id'

export default {
  name: 'video-details',
  data () {
    return {
      video: {
        data: {
          title: null,
          titleDue: null,
          titleComplete: null,
          thumbnail: null,
          thumbnailDue: null,
          thumbnailComplete: null,
          scriptDue: null,
          scriptComplete: null,
          filmDue: null,
          filmComplete: null,
          editDue: null,
          editComplete: null,
          tags: null,
          tagsDue: null,
          tagsComplete: null,
          description: null,
          descriptionDue: null,
          descriptionComplete: null,
          uploadDue: null,
          uploadComplete: null,
          promoteDue: null,
          promoteComplete: null,
          publishDue: null,
          publishComplete: null,
          engageDue: null,
          engageComplete: null,
          shortDescription: null,
          youtubeURL: null,
          youtubeVideoId: null,
        },
      },
      cloneVideo: null,
      today: null,
      isVisibleEditTitle: false,
      isVisibleEditDescription: false,
      characterCount: null,
      daysFromPublish: null,
      channelName: null,
      showThumbnailDueModal: false,
      uploadValue: null,
      hasChanges: false,
      newTag: null,
    }
  },
  created () {
    this.getToday()
    this.deepClone()
  },
  computed: {
    ...mapState(['creator']),
    ...mapState(['youtube']),
    titleChecker() {
      if (this.video.data.titleDue > this.today) {
        return 'future'
      } else if (this.video.data.titleDue === this.today) {
        return 'today'
      } else return 'past'
    },
    titleCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.titleDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    thumbnailChecker() {
      if (this.video.data.thumbnailDue > this.today) {
        return 'future'
      } else if (this.video.data.thumbnailDue === this.today) {
        return 'today'
      } else return 'past'
    },
    thumbnailCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.thumbnailDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    scriptChecker() {
      if (this.video.data.scriptDue > this.today) {
        return 'future'
      } else if (this.video.data.scriptDue === this.today) {
        return 'today'
      } else return 'past'
    },
    scriptCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.scriptDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    filmChecker() {
      if (this.video.data.filmDue > this.today) {
        return 'future'
      } else if (this.video.data.filmDue === this.today) {
        return 'today'
      } else return 'past'
    },
    filmCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.filmDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    editChecker() {
      if (this.video.data.editDue > this.today) {
        return 'future'
      } else if (this.video.data.editDue === this.today) {
        return 'today'
      } else return 'past'
    },
    editCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.editDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    tagsChecker() {
      if (this.video.data.tagsDue > this.today) {
        return 'future'
      } else if (this.video.data.tagsDue === this.today) {
        return 'today'
      } else return 'past'
    },
    tagsCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.tagsDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    descriptionChecker() {
      if (this.video.data.descriptionDue > this.today) {
        return 'future'
      } else if (this.video.data.descriptionDue === this.today) {
        return 'today'
      } else return 'past'
    },
    descriptionCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.descriptionDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    uploadChecker() {
      if (this.video.data.uploadDue > this.today) {
        return 'future'
      } else if (this.video.data.uploadDue === this.today) {
        return 'today'
      } else return 'past'
    },
    uploadCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.uploadDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    promoteChecker() {
      if (this.video.data.promoteDue > this.today) {
        return 'future'
      } else if (this.video.data.promoteDue === this.today) {
        return 'today'
      } else return 'past'
    },
    promoteCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.promoteDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    publishChecker() {
      if (this.video.data.publishDue > this.today) {
        return 'future'
      } else if (this.video.data.publishDue === this.today) {
        return 'today'
      } else return 'past'
    },
    publishCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.publishDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
    engageChecker() {
      if (this.video.data.engageDue > this.today) {
        return 'future'
      } else if (this.video.data.engageDue === this.today) {
        return 'today'
      } else return 'past'
    },
    engageCounter() {
      const now = moment()
      const remainingDays = moment.duration(now.diff(this.video.data.engageDue)).asDays()
      const roundedDays = Math.round(remainingDays)
      return roundedDays
    },
  },
  beforeRouteEnter (to, from, next) {
    console.log('beforeRouteEnter')
    next(vm => {
      console.log('vm')
      vm.video = to.params.video
      vm.cloneVideo = JSON.parse(JSON.stringify(to.params.video))
      console.log(vm.video)
      console.log(vm.cloneVideo)
    })
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    getToday () {
      this.today = moment().format('YYYY-MM-DD')
    },
    deepClone() {
      console.log('cloneVideo >> ', this.cloneVideo)
    },
    characterCounter() {
      this.characterCount = this.cloneVideo.data.description.length
    },
    editTitle() {
      this.isVisibleEditTitle = true
    },
    hideEdit() {
      console.log('hideEdit')
      this.isVisibleEditTitle = false
      this.isVisibleEditDescription = false
      this.cloneVideo.data = JSON.parse(JSON.stringify(this.video.data))
    },
    editDescription() {
      this.isVisibleEditDescription = true
      this.characterCounter()
    },
    // hideDescriptionEdit() {
    //   this.isVisibleEditDescription = false
    // },
    openYouTubeAnalytics() {
      window.open(`https://studio.youtube.com/video/${this.youtubeVideoId}/analytics/tab-overview/period-default`)
    },
    setHasChanges(type) {
      // this.hasChanges = true
      this.$store.commit('creator/hasChanges')
      if (type === 'delete') {
      } else if (this.video.change === 'create') {
      } else this.video.change = 'update'
    },
    fetchData () {
      console.log('fetchData')
    },
    updateVideo() {
      this.video.data = JSON.parse(JSON.stringify(this.cloneVideo.data))
      this.setHasChanges('update')
      this.hideEdit()
    },
    removeVideo() {
      console.log('removeVideo')
      this.$store.commit('creator/videos/removeVideo', {
        video: this.video,
      })
      this.setHasChanges('delete')
      this.$router.push('/dashboard')
    },
    previewImage(event) {
      console.log('previewImage')
      if (!event.target.files[0]) {
        event.preventDefault()
        alert('No file chosen')
      } else if (event.target.files[0] > 2000000) {
        event.preventDefault()
        alert('File too big (must be 2mb or less)')
      } else {
        this.uploadValue = 0
        this.cloneVideo.data.thumbnail = event.target.files[0]
        this.onUpload()
      }
    },
    onUpload() {
      if (this.cloneVideo.data.thumbnail.size > 2000000) {
        this.uploadValue = 'File size is too big!'
      } else {
        const storageRef = firebaseStorage.child('userImages/' + this.video.videoID).put(this.cloneVideo.data.thumbnail)
        storageRef.on('state_changed', snapshot => {
          this.uploadValue = (Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100) + '% uploaded')
          console.log(this.uploadValue)
        }, error => { console.log(error.message) },
        () => {
          this.uploadValue = 'Upload Complete'
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.cloneVideo.data.thumbnail = url
            console.log('thumbnailURL >> ', this.cloneVideo.data.thumbnail)
            this.updateVideo()
          })
        },
        )
      }
    },
    addTag() {
      this.cloneVideo.data.tags.push(this.newTag)
      this.newTag = ''
    },
    removeTag(tag) {
      const index = this.cloneVideo.data.tags.indexOf(tag)
      this.cloneVideo.data.tags.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<style lang="scss">
@import '@/components/mixins.scss';

.icon {
  margin-right: 1rem;
  color: white;
}

.planner-page {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.planner-header {
  flex: 1 1 3000px;
}

.planner-video {
  flex: 1 1 $lg-max-width;
}

.planner-todos {
  flex: 1 1 400px;
}

.video-tag {
  background: $primary;
  border: none;
  border-radius: 5px;
  margin: .1rem;
  padding: .5rem;
  i.remove {
    visibility: hidden;
    color: lightgrey;
  }
  &:hover {
    i.remove {
      visibility: visible;
    }
  }
}

</style>
